import React from "react";
import {
  Card,
  CardContent,
  CardActions,
  Typography,
  Button,
  Box,
  Chip,
  LinearProgress,
  IconButton,
  Grid,
} from "@mui/material";
import {
  Edit as EditIcon,
  Assignment as AssignmentIcon,
} from "@mui/icons-material";

const SummaryCard = ({
  title,
  subtitle,
  status = "Not Started",
  statusColor = "default",
  data = null,
  metrics = [],
  onAction,
  actionLabel = "Take Questionnaire",
  showProgress = false,
  progressValue = 0,
  secondaryAction,
  titleExtra,
}) => {
  return (
    <Card
      variant="outlined"
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        transition: "all 0.3s ease",
        "&:hover": {
          boxShadow: 3,
          transform: "translateY(-2px)",
        },
      }}
    >
      <CardContent sx={{ flexGrow: 1 }}>
        <Box
          sx={{
            mb: 2,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
          }}
        >
          <Box>
            <Typography variant="h6" gutterBottom>
              {title}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {subtitle}
            </Typography>
          </Box>
          {titleExtra}
        </Box>

        {status && !titleExtra && (
          <Chip label={status} color={statusColor} size="small" />
        )}

        {showProgress && (
          <Box sx={{ mt: 2, mb: 1 }}>
            <LinearProgress variant="determinate" value={progressValue} />
            <Typography variant="caption" color="text.secondary">
              {`${progressValue}% Complete`}
            </Typography>
          </Box>
        )}

        {metrics.length > 0 && (
          <Grid container spacing={2} sx={{ mb: 2 }}>
            {metrics.map((metric, index) => (
              <Grid item xs={6} key={index}>
                <Typography
                  variant="caption"
                  color="text.secondary"
                  display="block"
                >
                  {metric.label}
                </Typography>
                <Typography variant="body1">{metric.value}</Typography>
              </Grid>
            ))}
          </Grid>
        )}
      </CardContent>

      <CardActions sx={{ justifyContent: "flex-end", p: 2 }}>
        {status === "Completed" ? (
          <Button
            startIcon={<EditIcon />}
            onClick={onAction}
            variant="outlined"
            color="primary"
          >
            {actionLabel}
          </Button>
        ) : (
          <Button
            startIcon={<AssignmentIcon />}
            onClick={onAction}
            variant="contained"
            color="primary"
          >
            {actionLabel}
          </Button>
        )}
        {secondaryAction}
      </CardActions>
    </Card>
  );
};

export default SummaryCard;
